export const pageNameToRelativePath = {
    "myHome": "/myHome",
    "incidents": "/incidents",
    "reports": "/reports",
    "notifications": "/notifications"
}